import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {FooterModule} from '../footer/footer.module';
import {RouterModule} from '@angular/router';
import {NgHelmetModule} from 'ng-helmet';
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";
import {IconComponent} from '../shared/components/icon/icon.component';
import {ResponsiveImgComponent} from '../shared/components/responsive-img/responsive-img.component';
import {AccentPipe} from '../pipes/accent.pipe';
import {MatDividerModule} from "@angular/material/divider";
import {SelectLanguageModule} from '../select-language/select-language.module';

import {TalentSearchV2Component} from './talent-search-v2.component';
import {V2TsHeaderComponent} from './components/ts-header/ts-header.component';
import {V2HeroSectionComponent} from './components/hero-section/hero-section.component';
import {V2TrustedBySectionComponent} from './components/trusted-by-section/trusted-by-section.component';
import {V2TalentPoolSectionComponent} from './components/talent-pool-section/talent-pool-section.component';
import {V2StatsBandSectionComponent} from './components/stats-band-section/stats-band-section.component';
import {V2StepsSectionComponent} from './components/steps-section/steps-section.component';
import {V2ExactHireSectionComponent} from './components/exact-hire-section/exact-hire-section.component';
import {V2RankingSectionComponent} from './components/ranking-section/ranking-section.component';
import {V2PipelineSectionComponent} from './components/pipeline-section/pipeline-section.component';
import {V2PricingSectionComponent} from './components/pricing-section/pricing-section.component';
import {V2TestimonialsSectionComponent} from './components/testimonials-section/testimonials-section.component';
import {V2FaqSectionComponent} from './components/faq-section/faq-section.component';
import {V2CtaSectionComponent} from './components/cta-section/cta-section.component';

@NgModule({
  declarations: [
    TalentSearchV2Component,
    V2TsHeaderComponent,
    V2HeroSectionComponent,
    V2TrustedBySectionComponent,
    V2TalentPoolSectionComponent,
    V2StatsBandSectionComponent,
    V2StepsSectionComponent,
    V2ExactHireSectionComponent,
    V2RankingSectionComponent,
    V2PipelineSectionComponent,
    V2PricingSectionComponent,
    V2TestimonialsSectionComponent,
    V2FaqSectionComponent,
    V2CtaSectionComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FooterModule,
    RouterModule,
    NgHelmetModule,
    MatIconModule,
    MatMenuModule,
    IconComponent,
    ResponsiveImgComponent,
    AccentPipe,
    MatDividerModule,
    SelectLanguageModule,
  ],
})
export class TalentSearchV2Module {}
